$(document).ready(function () {
  $.cookie.defaults = { secure: window.location.protocol == 'https:' };
});
